import React, { useState } from 'react'
import { SupplierReportsData } from '../../../../constants/InverntoryConstants'
import { useTranslation } from 'react-i18next'

function SupplierReport () {
  const [hoverIndex, setHoverIndex] = useState(-1)
  const { t } = useTranslation()
  return (
    <div className='main-page-container'>
      <div className='grid grid-cols-2 gap-x-4 gap-y-2 lg:grid-cols-4 mt-4'>
        {SupplierReportsData(t)?.map((data, index) => (
          <div
            key={index}
            onMouseEnter={() => setHoverIndex(index)}
            onMouseLeave={() => setHoverIndex(-1)}
            className={`bg-gray-50 h-[70px] cursor-pointer px-4 flex items-center gap-3 border border-gray-100 rounded-md ${
              hoverIndex === index ? 'bg-white border-primary' : ''
            }  `}
          >
            <div className='icon-bg-container'>{data?.icon}</div>
            <h5 className='text-16-gray !font-semibold'>{data?.title}</h5>
          </div>
        ))}
      </div>
    </div>
  )
}

export default SupplierReport
